<template>
    <div class="orderDetail">
<!--        <el-card>-->
<!--            <el-page-header v-if="from == 'rfq'" @back="goBack" :content="'审批明细('+ orderId + ')'"></el-page-header>-->
<!--            <el-breadcrumb v-if="from == 'menu'" separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>审核配置</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>审批明细</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">

            <el-card>


                 <el-table
                    :data="proData"
                    size="mini"
                    v-loading="loading"
                    :header-cell-style="tableHeaderColor" border
                    class="tableBaseInfo"
                    style="width: 100%;border-bottom: none !important;">

                     <el-table-column prop="stepName" label="审批步骤" width="150"  >
                         <template slot-scope="scope">

                             {{scope.row.step+'、'+scope.row.stepName}}

                         </template>
                     </el-table-column>
                     <el-table-column prop="name" label="审批人" width="auto"  :min-width="80" />

                     <el-table-column prop="result" label="审批结果" align="center" width="80">
                         <template slot-scope="scope">

                             {{scope.row.result==0?'通过':'驳回'}}

                         </template>
                     </el-table-column>
                     <el-table-column prop="reason" label="审批理由" align="center" width="auto"  :min-width="150"/>
                     <el-table-column prop="detail" label="驳回明细" align="center" width="380" >
                         <template slot-scope="scope">
                             <template
                                     v-if="scope.row.detailList!=null">
                                 <el-table :row-style="{height:'20px'}" :cell-style="{padding: '0'}" :data="scope.row.detailList"   max-height="200" style="width: 100%;height:100%;">
                                     <!--                                    <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>-->
                                     <el-table-column prop="reason" align="center" label="商品"  :min-width="140" width="auto"  >
                                         <template slot-scope="scope">

                                             {{scope.row.detail.name}}

                                         </template>

                                     </el-table-column>
                                     <el-table-column prop="reason" align="center" label="驳回理由"  width="200" ></el-table-column>


                                 </el-table>
                             </template>
                         </template>

                     </el-table-column>
                     <el-table-column prop="detailNum" label="数量" align="center" width="330" >
                         <template slot-scope="scope">
                             <template
                                     v-if="scope.row.numList!=null">
                                 <el-table :row-style="{height:'20px'}" :cell-style="{padding: '0'}" :data="scope.row.numList"   max-height="200" style="width: 100%;height:100%;">
                                     <!--                                    <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>-->
                                     <el-table-column prop="reason" align="center" label="商品" width="auto"   :min-width="140" >
                                         <template slot-scope="scope">
                                             {{scope.row.detail.name}}
                                         </template>
                                     </el-table-column>
                                     <el-table-column prop="oldNum" align="center" label="原始数量"  width="80" ></el-table-column>
                                     <el-table-column prop="num" align="center" label="修改数量"  width="80" ></el-table-column>

                                 </el-table>
                             </template>
                         </template>
                     </el-table-column>

                </el-table>

            </el-card>
        </main>

    </div>
</template>
<script>

export default {
    data() {
        return {
            id:"",
            loading: false,
            loading1: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            reviewVisible:false,
            numVisible:false,

            itemForm: {
                detailId:"",//
                workflowId:"",
                step:"",
                orderId:"",
                num:"",
                oldNum:"",
                unit:"件"

            },
            infoData:{},
            invoiceData: [],//发票信息
            deliverData: [],//发票及货物接收信息
            orderData:[],//销售订单
            taxData: [],//含税价格
            proData: [],//产品信息
            rules: {
                num: [
                    {required: true, message: '请输入数量', trigger: 'blur'}
                ],
            }



        }
    },
    props: ["from", "orderId"],

    methods: {
        onSearch() {
            const url = "/admin/rfq/orderDetail";
            if(this.orderId) {
                this.loading = true;
                let _this = this
                this.$axios.post(url,{
                    cond:{orderId:this.orderId},
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function() {
                });
            }
        },

        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        goBack() {
            this.$router.go(-1);
        },

        hiddenHeaderRow({ rowIndex }) {
            if (rowIndex == 1) {
                //隐藏第二行
                return "hiddenClass";
            }
        },
        hiddenHeaderRow0({ rowIndex }) {
            if (rowIndex > 0) {
                //隐藏第二行
                return "hiddenClass";
            }
        },
        // 合并客户基本信息表格客户名称单元格
        arraySpanMethod1({ rowIndex, columnIndex }) {
            if (rowIndex == 0) {
                if (columnIndex != 0) {
                    return [1, 2];
                }
            }
        },
        tableHeaderColor ({ rowIndex, columnIndex }) {
            if (rowIndex === 0 && columnIndex === 0) {
                return { background:'#dfdfdf',fontSize:'14px',color:'black'}
            } else if (rowIndex === 0 && columnIndex !== 0) {
                return { background: '#dfdfdf', border: '1',color:'black'}
            } else {
                return { background: '#dfdfdf'}
            }
        },
        //columnStyle( {row, column, rowIndex, columnIndex}) {
            columnStyle( { columnIndex}) {

                //第一三列
                if (columnIndex == 0 || columnIndex == 2) {
                    //字体颜色
                    return {background:'#dfdfdf',fontWeight:'bold',color:'black'};
                }
            return {fontSize:'14px',color:'black'};

        },
        columnStyleO() {
            return {fontSize:'14px',color:'black'};

        },
        editIt(){
            let that = this;
            let cond = {...this.itemForm};

            this.$refs.itemForm.validate(valid => {
                if (valid) {
                    if(this.itemForm.oldNum == this.itemForm.num){
                        that.$notify({
                            title: '提示',
                            message: '请修改商品数量',
                            type: 'info'
                        });
                        return;

                    }
                    let msg = "确认修改商品数量为"+cond.num + cond.unit;
                    this.$confirm(msg+'吗？', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        cond={orderId:this.orderId,step:this.step,
                            workflowId:this.workflowId,detailId:this.itemForm.detailId,num:this.itemForm.num};
                        this.$axios.post("/admin/rfq/editNum", cond)
                            .then(function (response) {
                                let resp = response.data;
                                if (resp.header.status == 0) {

                                    that.numVisible = false;
                                    if (resp.data == true) {//修改数量完毕

                                        that.$notify({
                                            title: '成功',
                                            message: '数据保存成功',
                                            type: 'success'
                                        });
                                        that.info();
                                        that.infoOrder();
                                    }


                                } else {
                                    that.$notify.error({
                                        title: '错误',
                                        message: resp.header.msg
                                    });
                                }
                            });
                    });
                }
            });






        },

        detail() {
            const url = "/admin/rfq/reviewDetail";
            if (this.orderId) {
                this.loading1 = true;
                let _this = this
                this.$axios.post(url, this.orderId).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.loading1 = false;
                        _this.proData = resp.data;
                    }
                });
            }
        }


    },
    created() {
        let paramsStore;
        const params = sessionStorage.getItem("params");
        if(params) {
            paramsStore = JSON.parse(params);
        }
        const { orderId } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
        this.orderId = orderId;
        this.detail();


    },


}
</script>
<style lang="scss" scoped>
    .tableBaseInfo{
        font-size: 13px !important;
    }


</style>